<template>
  <div class="event">
    <a-timeline mode="alternate">
      <a-timeline-item v-for="(ev, index) in evs" :key="'ev' + index">
        <span>{{ev.time}}</span>{{ev.name}}
      </a-timeline-item>
    </a-timeline>
  </div>
</template>

<script>

export default {
  data () {
    return {
      evs: [
        { time: '2019.05', name: '捐赠苏州大学8000万元，支持独墅湖校区体育馆及学生活动中心建设'},
        { time: '2019.04', name: '荣获2019年中国慈善榜“慈善榜样”'},
        { time: '2019.04', name: '苏州金螳螂公益慈善基金会党支部正式成立'},
        { time: '2019.01', name: '获得2018年度公益性捐赠税前扣除资格【苏财税（2019）12号】'},
        { time: '2018.11', name: '金狮社区老人日间照料中心落成'},
        { time: '2018.09', name: '荣获苏州慈善奖最具影响力慈善组织'},
        { time: '2018.09', name: '通过苏州市社会组织“双随机”抽查'},
        { time: '2018.05', name: '“幸福亮居”助残工程正式启动'},
        { time: '2018.03', name: '获得2017年公益性捐赠税前扣除资格【苏财税（2018）3号/4号】'},
        { time: '2017.12', name: '获得中国社会组织评估4A等级认证【苏社评（2017）第48号】'},
        { time: '2017.06', name: '认定为苏州首家“慈善组织”'},
        { time: '2017.05', name: '获得非营利组织免税资格【苏财预（2017）42号】'},
        { time: '2017.03', name: '娄江社区老人日间照料中心落成'},
        { time: '2017.03', name: '西北街社区老人日间照料中心落成'},
        { time: '2016.11', name: '金螳螂志愿服务团队注册成立'},
        { time: '2016.10', name: '“苏善·携手乐龄计划”正式启动'},
        { time: '2016.06', name: '“千人工匠”精准扶贫计划正式启动'},
        { time: '2015.07', name: '金螳螂“工业园区慈善医疗”专项基金成立'},
        { time: '2015.06', name: '“启航助学”专项基金正式成立'},
        { time: '2015.05', name: '“生命之光”爱心救助基金在苏州大学附属第一医院、第二医院捐赠成立'},
        { time: '2015.05', name: '“情暖心窝”爱心救助基金在苏州大学附属儿童医院捐赠成立'},
        { time: '2015.04', name: '苏州大学金螳螂建筑学院教育发展基金捐赠成立'},
        { time: '2015.03', name: '金螳螂公益慈善基金会正式在苏州市民政局正式注册成立'}       
      ]
    }
  },
  name: 'event',
  components: {
  }
}
</script>